import { isThisYear } from 'date-fns';

import { getDateFromDateString } from './getDateFromDateString';

/**
 * Returns true if a date falls within the current year up until today.
 * @param date Any string that can act as an argument to the Date constructor
 */
export const isInYearToDate = (date?: Maybe<string>): boolean => {
    if (date === null || date === undefined) {
        return false;
    }

    return isThisYear(getDateFromDateString(date));
};
